module.exports = __webpack_public_path__ + "static/combination-of-different-series-types-af7053930fe3e20ed522198ec7d06c92.png";